import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

interface StepLoaderProps {
  message?: string
}

export const StepLoader: React.FC<StepLoaderProps> = ({
  message = 'Cargando...'
}) => (
  <Box
    sx={{
      position: 'absolute',
      inset: 0,
      zIndex: 20,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.88)',
      gap: 2
    }}
  >
    <CircularProgress size={48} />
    <Typography variant='body2' color='text.secondary' fontWeight={500}>
      {message}
    </Typography>
  </Box>
)
